_getTagOptions